export default __webpack_public_path__ + "static/media/notificacion.1aea1803.mp3";